export default {
  // Header
  "title": "랜덤 포켓몬 생성기",
  "subtitle": "당신의 선호도에 따라 랜덤한 포켓몬을 생성합니다",
  "home": "홈",
  "whichPokemonAmI": "나는 어떤 포켓몬일까?",
  "aboutUs": "회사 소개",
  "contactUs": "문의하기",
  "privacyPolicy": "개인정보 처리방침",
  
  // Filters
  "filterTitle": "필터 옵션",
  "generateButton": "랜덤 포켓몬 생성하기",
  "generating": "생성 중...",
  "numberOfPokemon": "포켓몬 수",
  "type": "타입",
  "generation": "세대",
  "minimumRarity": "최소 희귀도 (1-10)",
  "anyType": "모든 타입",
  "anyGeneration": "모든 세대",
  "anyRarity": "모든 희귀도",
  "countingPokemon": "일치하는 포켓몬 계산 중",
  "matchingPokemonCount": "{{count}}개의 포켓몬이 필터와 일치합니다",
  
  // Pokemon Types
  "normal": "노말",
  "fire": "불꽃",
  "water": "물",
  "electric": "전기",
  "grass": "풀",
  "ice": "얼음",
  "fighting": "격투",
  "poison": "독",
  "ground": "땅",
  "flying": "비행",
  "psychic": "에스퍼",
  "bug": "벌레",
  "rock": "바위",
  "ghost": "고스트",
  "dragon": "드래곤",
  "dark": "악",
  "steel": "강철",
  "fairy": "페어리",
  
  // Generations
  "Generation I": "1세대",
  "Generation II": "2세대",
  "Generation III": "3세대",
  "Generation IV": "4세대",
  "Generation V": "5세대",
  "Generation VI": "6세대",
  "Generation VII": "7세대",
  "Generation VIII": "8세대",
  "Generation IX": "9세대",
  
  // Evolution Stage
  "evolutionStage": "진화 단계",
  "evolutionStageAll": "모든 단계",
  "evolutionStageFullyEvolved": "최종 진화",
  "evolutionStageNotFullyEvolved": "미진화",
  
  // About Section
  "aboutTitle": "랜덤 포켓몬 생성기에 대하여",
  
  // Section titles
  "introTitle": "랜덤 포켓몬 생성기에 오신 것을 환영합니다",
  "howToUseTitle": "랜덤 포켓몬 생성기 사용법",
  "benefitsTitle": "랜덤 포켓몬 생성기 사용의 장점",
  "historyTitle": "포켓몬의 역사",
  "popularPokemonTitle": "인기 있는 포켓몬",
  "popularGamesTitle": "인기 있는 포켓몬 게임",
  "tradingContestsTitle": "포켓몬 교환 및 콘테스트",
  "faqTitle": "자주 묻는 질문",
  "conclusionTitle": "오늘 랜덤 포켓몬 모험을 시작하세요!",
  
  // Footer
  "copyright": "© 2025 randompokemon.games",
  "trademark": "포켓몬과 포켓몬 캐릭터 이름은 닌텐도의 상표입니다.",
  "linksTitle": "유용한 링크",
  
  // About Us Page
  "aboutUsTitle": "회사 소개",
  "aboutUsWhoWeAre": "우리는 누구인가",
  "aboutUsWhoWeAreContent1": "랜덤 포켓몬 생성기에 오신 것을 환영합니다. 이 도구는 열정적인 포켓몬 팬들이 만든 팬 제작 도구입니다. 우리의 여정은 2023년, 프로그래밍과 포켓몬을 모두 사랑하는 개발자 그룹이 커뮤니티를 위한 유용한 도구를 만들기로 결정했을 때 시작되었습니다.",
  "aboutUsWhoWeAreContent2": "우리 팀은 전 세계 포켓몬 팬들에게 최상의 경험을 제공하기 위해 함께 일하는 개발자, 디자이너, 콘텐츠 크리에이터로 구성되어 있습니다.",
  "aboutUsOurMission": "우리의 미션",
  "aboutUsOurMissionContent1": "우리는 포켓몬의 세계를 모든 사람에게 더 접근하기 쉽고 즐겁게 만드는 것을 목표로 합니다. 우리의 도구는 트레이너들이 새로운 포켓몬을 발견하고, 균형 잡힌 팀을 만들고, 완벽한 포켓몬 매치를 찾을 수 있도록 설계되었습니다.",
  "aboutUsOurMissionContent2": "우리는 포켓몬 프랜차이즈를 존중하면서 커뮤니티에 가치를 더하는 사용자 친화적이고 정확하며 재미있는 경험을 제공하기 위해 노력하고 있습니다.",
  "aboutUsOurTeam": "우리 팀",
  "aboutUsOurTeamContent1": "우리의 다양한 팀은 웹 개발, 포켓몬 지식, 사용자 경험 디자인, 커뮤니티 관리 분야의 전문성을 한데 모았습니다. 우리는 포켓몬에 대한 사랑과 고품질 도구를 만들겠다는 약속으로 하나가 되었습니다.",
  "aboutUsOurTeamContent2": "각 팀원은 랜덤 포켓몬 생성기를 최고로 만들기 위해 자신만의 독특한 기술과 관점을 기여합니다.",
  "aboutUsJoinUs": "함께하세요",
  "aboutUsJoinUsContent": "우리는 항상 우리 커뮤니티에 합류할 열정적인 개인을 찾고 있습니다. 당신이 개발자, 디자이너, 포켓몬 전문가, 또는 열정적인 사용자인지에 관계없이, 당신의 피드백과 기여를 환영합니다.",
  
  // Contact Us Page
  "contactUsTitle": "문의하기",
  "contactUsGetInTouch": "연락하기",
  "contactUsGetInTouchContent": "랜덤 포켓몬 생성기에 대한 질문, 제안 또는 피드백이 있으신가요? 여러분의 의견을 듣고 싶습니다! 다음은 우리 팀에 연락할 수 있는 방법입니다.",
  "contactUsEmail": "이메일",
  "contactUsPhone": "전화",
  "contactUsAddress": "주소",
  "contactUsHelpSupport": "도움 및 지원",
  "contactUsHelpSupportContent": "우리의 도구 사용에 도움이 필요하거나 문제가 발생했나요? 우리의 지원 팀이 도와드리겠습니다.",
  "contactUsFAQ": "자주 묻는 질문",
  "contactUsFAQContent": "연락하기 전에 많은 일반적인 질문과 문제를 다루는 FAQ 섹션을 확인해 보세요.",
  "contactUsBugReport": "버그 신고",
  "contactUsBugReportContent": "버그나 기술적 문제를 발견하셨다면, 제목에 '버그 리포트'라고 적어 이메일로 알려주세요.",
  
  // Privacy Policy Page
  "privacyPolicyTitle": "개인정보 처리방침",
  "privacyPolicyIntro": "소개",
  "privacyPolicyIntroContent": "랜덤 포켓몬 생성기에서는 귀하의 개인정보를 존중하고 개인 데이터 보호에 최선을 다하고 있습니다. 이 개인정보 처리방침은 웹사이트 사용 시 정보를 수집, 사용, 보호하는 방법을 설명합니다.",
  "privacyPolicyInformation": "수집하는 정보",
  "privacyPolicyInformationContent": "우리는 서비스를 제공하고 개선하기 위해 최소한의 정보만 수집합니다. 다음과 같은 정보가 포함될 수 있습니다:",
  "privacyPolicyInformationItem1": "사용 데이터(방문한 페이지, 사이트에서 보낸 시간, 사용한 기능 등)",
  "privacyPolicyInformationItem2": "장치 정보(브라우저 유형, 운영 체제, 화면 해상도)",
  "privacyPolicyInformationItem3": "IP 주소 및 대략적인 위치(국가 수준만)",
  "privacyPolicyCookies": "쿠키 및 유사 기술",
  "privacyPolicyCookiesContent": "우리는 웹사이트에서의 경험을 향상시키기 위해 쿠키를 사용합니다. 이 작은 텍스트 파일은 우리가 귀하의 선호도를 기억하고 사이트 사용 방식을 분석할 수 있게 해줍니다. 브라우저 설정을 통해 쿠키를 제어할 수 있습니다.",
  "privacyPolicyThirdParty": "제3자 서비스",
  "privacyPolicyThirdPartyContent": "우리 웹사이트는 분석 제공업체 및 콘텐츠 전송 네트워크와 같은 제3자 서비스를 사용할 수 있습니다. 이러한 서비스는 귀하의 웹사이트 사용에 관한 정보를 수집할 수 있습니다. 우리는 모든 제3자가 귀하의 개인정보를 존중하고 데이터를 적절히 처리하도록 보장합니다.",
  "privacyPolicySecurity": "데이터 보안",
  "privacyPolicySecurityContent": "우리는 귀하의 정보를 무단 접근, 변경 또는 공개로부터 보호하기 위해 적절한 보안 조치를 구현합니다. 그러나 인터넷을 통한 전송은 100% 안전하지 않으므로 절대적인 보안을 보장할 수 없습니다.",
  "privacyPolicyChanges": "이 정책의 변경",
  "privacyPolicyChangesContent": "우리는 개인정보 처리방침을 때때로 업데이트할 수 있습니다. 이 페이지에 새로운 개인정보 처리방침을 게시하고 '마지막 업데이트' 날짜를 업데이트하여 변경 사항을 알려드립니다.",
  "privacyPolicyContact": "문의하기",
  "privacyPolicyContactContent": "이 개인정보 처리방침에 대해 질문이 있으시면 연락처 페이지에 제공된 정보를 통해 문의해 주십시오.",
  "privacyPolicyLastUpdated": "마지막 업데이트",
  
  // Which Pokemon Am I Page
  "whichPokemonAmITitle": "나는 어떤 포켓몬일까?",
  "whichPokemonAmISubtitle": "당신에게 가장 잘 맞는 포켓몬을 찾아보세요",
  "enterYourName": "이름을 입력하세요",
  "namePlaceholder": "당신의 이름",
  "enterFavoriteColor": "좋아하는 색상을 선택하세요",
  "enterBirthMonth": "태어난 달을 선택하세요",
  "selectBirthMonth": "달을 선택하세요",
  "enterPersonalityTrait": "성격 특성을 선택하세요",
  "selectPersonalityTrait": "성격 특성 선택",
  "findMyPokemon": "내 포켓몬 찾기",
  "calculating": "계산 중...",
  "yourPokemonIs": "당신의 포켓몬은",
  "pokemonDescription": "설명",
  "personalityMatch": "성격 일치도",
  "yourCompatibility": "당신과의 호환성",
  "downloadImage": "이미지 다운로드",
  "shareResult": "결과 공유하기",
  "tryAgain": "다시 시도하기",
  "results": "결과",
  "aboutTool": "이 도구에 대하여",
  "howToUse": "사용 방법",
  "benefits": "장점",
  "faq": "자주 묻는 질문",
  "conclusion": "결론",
  
  // Error messages
  "nameRequired": "이름을 입력해 주세요",
  "colorRequired": "색상을 선택해 주세요",
  "monthRequired": "달을 선택해 주세요",
  "traitRequired": "성격 특성을 선택해 주세요",
  
  // Months
  "january": "1월",
  "february": "2월",
  "march": "3월",
  "april": "4월",
  "may": "5월",
  "june": "6월",
  "july": "7월",
  "august": "8월",
  "september": "9월",
  "october": "10월",
  "november": "11월",
  "december": "12월",
  
  // Personality Traits
  "brave": "용감함",
  "calm": "차분함",
  "timid": "겁이 많음",
  "jolly": "명랑함",
  "quiet": "조용함",
  "hasty": "성급함",
  "careful": "신중함",
  "lonely": "외로움",
  "bold": "대담함",
  "relaxed": "느긋함",
  "impish": "개구쟁이",
  "modest": "겸손함",
  
  // Size matching feature
  "enterHeightWeight": "키와 몸무게를 입력하세요 — 당신과 일치하는 포켓몬을 확인해보세요!",
  "whichPokemonMatchesSize": "당신의 체형과 일치하는 포켓몬은?",
  "youAreMostLike": "당신은 이것과 가장 비슷합니다",
  "nameLabel": "이름",
  "heightLabel": "키",
  "weightLabel": "몸무게",
  "heightValid": "유효한 키를 입력하세요 (1-300 cm)",
  "weightValid": "유효한 몸무게를 입력하세요 (1-500 kg)",
  "enterDetails": "세부 정보 입력",
  "finding": "찾는 중...",
  "errorFinding": "포켓몬을 찾는 중 오류가 발생했습니다",
  "matchResult": "{{name}}의 포켓몬은...",
  "similarityScore": "유사도 점수",
  "downloadStarted": "이미지 준비 중...",
  "downloadComplete": "이미지가 성공적으로 다운로드되었습니다!",
  "shareText": "저는 {{pokemon}}인 것을 발견했어요! 당신은 어떤 포켓몬인지 알아보세요!",
  "madeBy": "제작자",

  // New Page: Pokemon Randomizer - About Section Titles (Translated to Korean)
  "pokemonRandomizerPageAboutTitle": "궁극의 포켓몬 랜덤화기 경험 탐색",
  "pokemonRandomizer_whatIsItTitle": "포켓몬 랜덤화기란 정확히 무엇인가?",
  "pokemonRandomizer_featuresTitle": "저희 포켓몬 랜덤화기 도구의 주요 기능",
  "pokemonRandomizer_whyUseTitle": "왜 포켓몬 랜덤화기로 모험을 시작해야 하는가?",
  "pokemonRandomizer_gettingStartedTitle": "시작하기: 첫 포켓몬 랜덤화기 실행",
  "pokemonRandomizer_faqTitle": "포켓몬 랜덤화기: 자주 묻는 질문",

  // New keys for PokemonRandomizerPage.tsx H1 and subtitle (Translated to Korean)
  "pokemonRandomizerPageH1": "포켓몬 랜덤화 도구",
  "pokemonRandomizerPageSubtitle": "고급 랜덤화 도구로 독특한 포켓몬 경험을 만들어보세요.",

  // Sub-Footer
  subFooterToolsTitle: "도구",
  subFooterRandomPokemonGeneratorLink: "랜덤 포켓몬 생성기",
  subFooterPokemonRandomizerLink: "포켓몬 랜덤화 도구",
  subFooterWhichPokemonAmILink: "나는 어떤 포켓몬일까요?",

  subFooterPokemonDatabaseTitle: "포켓몬 데이터베이스",
  subFooterPokedexLink: "포켓몬 도감 (출시 예정)",
  subFooterTypeChartsLink: "타입 상성표 (출시 예정)",
  subFooterMoveListLink: "기술 목록 (출시 예정)",

  subFooterBlogTitle: "블로그",
  subFooterLatestArticlesLink: "최신 기사 (출시 예정)",
  subFooterGuidesTutorialsLink: "가이드 & 튜토리얼 (출시 예정)",

  // Pokedex Page
  "pokedexEyebrow": "포켓몬 데이터베이스",
  "pokedexPageTitle": "포켓덱스",
  "pokedexPageSubtitle": "모든 포켓몬을 검색하고 타입이나 세대로 필터링한 뒤, 페이지를 벗어나지 않고 더 자세한 정보를 확인하세요.",
  "pokedexSearchLabel": "검색",
  "pokedexSearchPlaceholder": "이름 또는 포켓덱스 번호로 검색",
  "pokedexAllGenerations": "모든 세대",
  "pokedexAllTypes": "모든 타입",
  "pokedexSortLabel": "정렬",
  "pokedexSortNumber": "번호 오름차순",
  "pokedexSortName": "이름 가나다순",
  "pokedexSortRarity": "희귀도 높은 순",
  "pokedexSortHeight": "키 큰 순",
  "pokedexSortWeight": "몸무게 무거운 순",
  "pokedexClearFilters": "필터 초기화",
  "pokedexTotalEntries": "전체",
  "pokedexFilteredEntries": "일치",
  "pokedexPageIndicator": "페이지",
  "pokedexInspect": "상세 보기",
  "pokedexShowingResults": "총 {{total}}개 중 {{start}}-{{end}} 표시",
  "pokedexPrevious": "이전",
  "pokedexNext": "다음",
  "pokedexPageStatus": "{{page}} / {{total}} 페이지",
  "pokedexEmptyTitle": "검색 조건에 맞는 포켓몬이 없습니다",
  "pokedexEmptyBody": "다른 이름, 세대, 또는 타입 필터를 시도해 보세요.",
  "pokedexLoadErrorTitle": "포켓덱스 데이터를 불러올 수 없습니다",
  "pokedexLoadErrorBody": "로컬 포켓몬 데이터베이스를 불러오지 못해 포켓덱스를 표시할 수 없습니다.",
  "pokedexDetailDescription": "포켓덱스 상세 정보",
  "pokedexDetailError": "현재 이 포켓몬 정보를 불러올 수 없습니다.",
  "pokedexDetailLoading": "포켓덱스 정보를 불러오는 중...",
  "pokedexOverviewTitle": "개요",
  "pokedexBaseExperience": "기본 경험치",
  "pokedexAbilitiesTitle": "특성",
  "pokedexStatsTitle": "기본 능력치",
  "pokedexMovesTitle": "대표 기술",
  "pokedexMovesLearnset": "습득 정보",
  "pokedexMovesUnavailable": "이 포켓몬의 기술 정보를 불러올 수 없습니다.",
  "pokedexMovesPower": "위력",
  "pokedexMovesAccuracy": "명중",
  "pokedexMovesPP": "PP",
  "pokedexMovesPriority": "우선도",
  "pokedexMovesEffect": "효과",
  "pokedexMovesEffectFallback": "현재 언어로 기술 효과 설명을 찾을 수 없습니다.",
  "pokedexMovesRoutes": "습득 경로",
  "pokedexMovesLevel": "레벨",
  "pokedexMoveMethodLevelUp": "레벨업",
  "pokedexVersionGroupScarletViolet": "스칼렛 / 바이올렛",
  "pokedexMoveMethodMachine": "기술머신",
  "pokedexMoveMethodEgg": "알기술",
  "pokedexMoveMethodTutor": "가르침",
  "pokedexMoveMethodEvolution": "진화",
  "pokedexMoveMethodFormChange": "폼 체인지",
  "pokedexMoveMethodSpecial": "특수",
  "pokedexMoveDamagePhysical": "물리",
  "pokedexMoveDamageSpecial": "특수",
  "pokedexMoveDamageStatus": "변화"
};
